module.exports={
	"name": "retold-data-service",
	"version": "2.1.5",
	"description": "Serve up a whole model!",
	"main": "source/Retold-Data-Service.js",
	"bin": {
		"retold-data-service-clone": "bin/retold-data-service-clone.js"
	},
	"scripts": {
		"start": "node bin/retold-data-service-clone.js",
		"coverage": "npx quack coverage",
		"test": "npx quack test",
		"brand": "node node_modules/pict-section-theme/bin/pict-section-theme-brand.js --manifest ../../../Retold-Modules-Manifest.json --module retold-data-service --favicons source/services/comprehension-loader/web/favicons && cp -r source/services/comprehension-loader/web/favicons source/services/data-cloner/web/favicons",
		"build": "node build-all.js",
		"build:cloner": "npx quack build",
		"build:loader": "node -e \"require('fs').writeFileSync('.quackage.json', require('fs').readFileSync('.quackage-comprehension-loader.json', 'utf8'))\" && npx quack build",
		"prepublishOnly": "npm run build",
		"build-test-model": "cd test && npx stricture -i model/ddl/BookStore.ddl",
		"docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t retold-data-service-image:local",
		"docker-dev-run": "docker run -it -d --name retold-data-service-dev -p 44444:8080 -p 43306:3306 -p 48086:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/retold-data-service\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" retold-data-service-image:local",
		"docker-dev-shell": "docker exec -it retold-data-service-dev /bin/bash",
		"docker-service-build": "docker build ./ -f Dockerfile_Service -t retold-data-service-server-image:local",
		"docker-service-run-test": "docker run -it --init -d --name retold-data-service -p 8086:8086 -p 43306:3306 -v \"$(pwd):/retold-data-service:z\" -u \"$(id -u):$(id -g)\" retold-data-service-server-image:local",
		"docker-service-run": "docker run -it --init -d --name retold-data-service -p 8086:8086 -p 43306:3306 -v \"$(pwd):/retold-data-service:z\" retold-data-service-server-image:local",
		"docker-service-shell": "docker exec -it retold-data-service /bin/bash",
		"test:integration": "node test/run-integration-tests.js",
		"test:integration:no-browser": "node test/run-integration-tests.js --skip-puppeteer",
		"test:all": "npx quack test && node test/run-integration-tests.js --skip-puppeteer",
		"postversion": "npx quack release postversion",
		"postpublish": "npx quack release postpublish",
		"publish:docker": "npx quack release publish --image",
		"release:patch": "npx quack release patch",
		"release:minor": "npx quack release minor",
		"release:major": "npx quack release major",
		"release:patch:image": "npx quack release patch --image",
		"release:minor:image": "npx quack release minor --image",
		"release:major:image": "npx quack release major --image"
	},
	"mocha": {
		"spec": [
			"test/RetoldDataService_tests.js",
			"test/Bundles_smoke_tests.js",
			"test/ComprehensionLoader_smoke_tests.js",
			"test/DataCloner_smoke_tests.js"
		],
		"diff": true,
		"extension": [
			"js"
		],
		"package": "./package.json",
		"reporter": "spec",
		"slow": "75",
		"timeout": "5000",
		"ui": "tdd",
		"watch-files": [
			"source/**/*.js",
			"test/**/*.js"
		],
		"watch-ignore": [
			"lib/vendor"
		]
	},
	"repository": {
		"type": "git",
		"url": "https://github.com/fable-retold/retold-data-service.git"
	},
	"keywords": [
		"entity",
		"behavior",
		"api"
	],
	"author": "Steven Velozo <steven@velozo.com> (http://velozo.com/)",
	"license": "MIT",
	"bugs": {
		"url": "https://github.com/fable-retold/retold-data-service/issues"
	},
	"homepage": "https://github.com/fable-retold/retold-data-service",
	"devDependencies": {
		"chai": "^4.5.0",
		"jsdom": "^25.0.1",
		"meadow-connection-sqlite": "^1.0.20",
		"mocha": "^11.0.1",
		"pict-docuserve": "^1.4.19",
		"puppeteer": "^24.40.0",
		"quackage": "^1.3.0",
		"stricture": "^4.0.6",
		"supertest": "^7.2.2"
	},
	"dependencies": {
		"bibliograph": "^1.0.0",
		"fable": "^3.1.75",
		"fable-serviceproviderbase": "^3.0.19",
		"meadow": "^2.0.43",
		"meadow-connection-manager": "^1.1.5",
		"meadow-connection-mysql": "^1.0.19",
		"meadow-endpoints": "^4.0.22",
		"meadow-integration": "^1.0.42",
		"meadow-migrationmanager": "^1.0.4",
		"orator": "^6.1.2",
		"orator-http-proxy": "^1.0.5",
		"orator-serviceserver-restify": "^2.0.11",
		"orator-static-server": "^2.1.4",
		"pict": "^1.0.372",
		"pict-provider-theme": "^1.1.2",
		"pict-section-connection-form": "^1.0.0",
		"pict-section-histogram": "^1.0.1",
		"pict-section-modal": "^1.1.4",
		"pict-section-theme": "^1.1.1",
		"pict-sessionmanager": "^1.0.2",
		"stricture": "^4.0.6"
	},
	"retold": {
		"brand": {
			"Hash": "retold-data-service",
			"Name": "Retold Data Service",
			"Tagline": "Schema-driven data movement and comprehension",
			"Palette": "ocean",
			"Icon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\" width=\"96\" height=\"96\">\n\t\t<defs>\n\t\t\t<clipPath id=\"frame-retold-data-service-filled-light\">\n\t\t\t\t<path d=\"M 48.00 2.00 L 87.84 25.00 L 87.84 71.00 L 48.00 94.00 L 8.16 71.00 L 8.16 25.00 Z\"/>\n\t\t\t</clipPath>\n\t\t</defs>\n\t\t<path d=\"M 48.00 2.00 L 87.84 25.00 L 87.84 71.00 L 48.00 94.00 L 8.16 71.00 L 8.16 25.00 Z\" fill=\"#23a6c7\"/>\n\t\t<g clip-path=\"url(#frame-retold-data-service-filled-light)\"><rect x=\"20\" y=\"20\" width=\"56\" height=\"56\" rx=\"8\" fill=\"rgba(255,255,255,0.18)\"/>\n\t\t\t\t\t<path d=\"M 48 30 L 70 48 L 48 66 L 26 48 Z\" fill=\"#e36b59\"/></g>\n\t\t<text x=\"48\" y=\"50\" text-anchor=\"middle\" dominant-baseline=\"central\"\n\t\t\tfont-family=\"-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif\"\n\t\t\tfont-size=\"28\" font-weight=\"600\"\n\t\t\tfill=\"#ffffff\" letter-spacing=\"-1\">RDS</text>\n\t</svg>",
			"IconType": "svg",
			"Favicon": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\" width=\"96\" height=\"96\">\n\t\t<defs>\n\t\t\t<clipPath id=\"fav-retold-data-service-light\">\n\t\t\t\t<path d=\"M 48.00 2.00 L 87.84 25.00 L 87.84 71.00 L 48.00 94.00 L 8.16 71.00 L 8.16 25.00 Z\"/>\n\t\t\t</clipPath>\n\t\t</defs>\n\t\t<path d=\"M 48.00 2.00 L 87.84 25.00 L 87.84 71.00 L 48.00 94.00 L 8.16 71.00 L 8.16 25.00 Z\" fill=\"#23a6c7\"/>\n\t\t<g clip-path=\"url(#fav-retold-data-service-light)\"><rect x=\"16\" y=\"16\" width=\"64\" height=\"64\" rx=\"10\" fill=\"rgba(255,255,255,0.22)\"/></g>\n\t\t<text x=\"48\" y=\"50\" text-anchor=\"middle\" dominant-baseline=\"central\"\n\t\t\tfont-family=\"-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif\"\n\t\t\tfont-size=\"60\" font-weight=\"800\"\n\t\t\tfill=\"#ffffff\" letter-spacing=\"-1\">R</text>\n\t</svg>",
			"FaviconDark": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\" width=\"96\" height=\"96\">\n\t\t<defs>\n\t\t\t<clipPath id=\"fav-retold-data-service-dark\">\n\t\t\t\t<path d=\"M 48.00 2.00 L 87.84 25.00 L 87.84 71.00 L 48.00 94.00 L 8.16 71.00 L 8.16 25.00 Z\"/>\n\t\t\t</clipPath>\n\t\t</defs>\n\t\t<path d=\"M 48.00 2.00 L 87.84 25.00 L 87.84 71.00 L 48.00 94.00 L 8.16 71.00 L 8.16 25.00 Z\" fill=\"#67c6de\"/>\n\t\t<g clip-path=\"url(#fav-retold-data-service-dark)\"><rect x=\"16\" y=\"16\" width=\"64\" height=\"64\" rx=\"10\" fill=\"rgba(255,255,255,0.22)\"/></g>\n\t\t<text x=\"48\" y=\"50\" text-anchor=\"middle\" dominant-baseline=\"central\"\n\t\t\tfont-family=\"-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif\"\n\t\t\tfont-size=\"60\" font-weight=\"800\"\n\t\t\tfill=\"#101418\" letter-spacing=\"-1\">R</text>\n\t</svg>",
			"Colors": {
				"Primary": "#23a6c7",
				"Secondary": "#e36b59",
				"PrimaryLight": "#23a6c7",
				"PrimaryDark": "#67c6de",
				"SecondaryLight": "#e36b59",
				"SecondaryDark": "#edb3aa"
			}
		}
	}
}
